import React from 'react';
import { isMobile, isTablet } from 'react-device-detect';

import '../styles/connectwallet.css';

const WalletButton = ({ connected, children }) => {
  const handleOpen = () => {
    {
      connected
        ? document
            .getElementsByClassName('walletbox')[0]
            .classList.add('connected')
        : document
            .getElementsByClassName('walletbox')[0]
            .classList.add('disconnected');
    }
  };

  const handleClose = () => {
    {
      connected
        ? document
            .getElementsByClassName('walletbox')[0]
            .classList.remove('connected')
        : document
            .getElementsByClassName('walletbox')[0]
            .classList.remove('disconnected');
    }
  };

  return (
    <div
      className="walletbox"
      onClick={handleClose}
      onMouseEnter={handleOpen}
      onMouseLeave={handleClose}
    >
      {children}
    </div>
  );
};

const WalletGridItem = ({ onClick, children }) => (
  <div
    className={'wallet-grid-item' + (onClick ? ' clickable' : '')}
    onClick={onClick}
    style={{ borderTopStyle: 'none' }}
  >
    <span>{children}</span>
  </div>
);

const Wallet = ({
  blockchain,
  connectWallet,
  connectCoinbase,
  connectWalletConnect,
  disconnectWallet,
}) => {
  const isConnected =
    Boolean(blockchain.account) && blockchain.smartContract !== null;
  const dotClass = isConnected ? 'green' : '';
  const status = blockchain.loading ? <>&nbsp;connecting</> : 'connect';

  if (isMobile || isTablet) {
    return null;
  }

  return (
    <WalletButton connected={isConnected}>
      <div id="wallet-dot" className={dotClass}></div>
      <div id="wallet-underline"></div>
      <div className="wallet-grid-container">
        {!isConnected ? (
          <>
            <WalletGridItem>{status}</WalletGridItem>
            <WalletGridItem onClick={connectWallet}>metamask</WalletGridItem>
            <WalletGridItem onClick={connectCoinbase}>coinbase</WalletGridItem>
            <WalletGridItem onClick={connectWalletConnect}>
              wallet<br></br>connect
            </WalletGridItem>
          </>
        ) : (
          <>
            <WalletGridItem>
              {' '}
              &nbsp;
              {blockchain.account.substring(0, 6)}...
              {blockchain.account.slice(-4)}{' '}
            </WalletGridItem>
            <WalletGridItem onClick={disconnectWallet}>
              disconnect
            </WalletGridItem>
          </>
        )}
      </div>
    </WalletButton>
  );
};

export default Wallet;
